import { Entity } from "../helpers/Entity"

export type IntegrationConfigurationValueAttributes = {
    integrationKey: string,
    key: string,
    values: object,
}

export type IntegrationConfigurationValueDto = {
    id: string,
    type: string,
    attributes: IntegrationConfigurationValueAttributes,
}

export const INTEGRATION_CONFIGURATION_KEYS = {
    defaultInventoryLocationId: "defaultInventoryLocationId"
}

export default class IntegrationConfigurationValue implements Entity {
    private dto: IntegrationConfigurationValueDto

    constructor(dto: IntegrationConfigurationValueDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "integration-configurations"
    }

    getId(): string {
        return this.dto.id
    }

    getKey(): string {
        return this.dto.attributes.key
    }

    getValues(): object {
        return this.dto.attributes.values
    }

    setValueLabel(valueKey: string, label: string) {
        if (valueKey in this.dto.attributes.values) {
            this.dto.attributes.values[valueKey] = label
        }
    }

    addValue(valueKey: string, label: string) {
        if (!(valueKey in this.dto.attributes.values)) {
            this.dto.attributes.values[valueKey] = label
        }
    }
}



// WEBPACK FOOTER //
// ./src/state/integration/IntegrationConfigurationValue.ts